import { Form, Input, Modal } from 'antd'
import { useRef, useState } from 'react'
import { displayMessage } from '../../../helpers/messages'
import api from '../../../services/api'

const STATUS_SUCCESS = 200

export function ModalCreateRecomendation({ isOpen, onClose, reloadRecommendations }) {
    const formRef = useRef()

    const [loading, setLoading] = useState(false)

    const onSubmit = async recommendation => {
        setLoading(true)
        try {
            const response = await api.recommendations.create(recommendation)

            if (response.status === STATUS_SUCCESS) {
                onClose(false)
                await reloadRecommendations()
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            title={displayMessage('RECOMMENDATION_CREATION')}
            centered
            open={isOpen}
            onOk={() => formRef.current.submit()}
            confirmLoading={loading}
            onCancel={() => onClose(false)}
            okText={displayMessage('FINISH')}
            maskClosable={false}
        >
            <Form onFinish={onSubmit} className="max-w-[700px] w-full" layout="vertical" requiredMark={false} ref={formRef}>
                <div className="flex flex-col gap-1">
                    <div className="">{displayMessage('TITLE')}</div>

                    <Form.Item name="title" rules={[{ required: true, message: displayMessage('DISPLAY_TILE') }]} className="mb-4">
                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={displayMessage('TITLE')} className={'w-full'} />
                    </Form.Item>
                </div>

                <div className="flex flex-col gap-1">
                    <div className="">{displayMessage('MODULE_DESCRIPTION')}</div>

                    <Form.Item name="description" rules={[{ required: true, message: displayMessage('DISPLAY_DESCRIPTION') }]} className="mb-4">
                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={displayMessage('MODULE_DESCRIPTION')} className={'w-full'} />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}
